/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M9.5 13.5L11 15L15 11"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16 3V3C18.2091 3 20 4.79086 20 7V14C20 16.8003 20 18.2004 19.455 19.27C18.9757 20.2108 18.2108 20.9757 17.27 21.455C16.2004 22 14.8003 22 12 22V22C9.19974 22 7.79961 22 6.73005 21.455C5.78924 20.9757 5.02433 20.2108 4.54497 19.27C4 18.2004 4 16.8003 4 14V7C4 4.79086 5.79086 3 8 3V3M16 3V3C16 1.89543 15.1046 1 14 1H10C8.89543 1 8 1.89543 8 3V3M16 3V3C16 4.10457 15.1046 5 14 5H10C8.89543 5 8 4.10457 8 3V3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M20 14V7.49991C20 5.01468 17.9853 3 15.5001 3C15.5001 4.10457 14.6047 5 13.5001 5H10.5001C9.39552 5 8.50009 4.10457 8.50009 3C6.01476 3 4 5.01476 4 7.50009V14C4 16.8003 4 18.2004 4.54497 19.27C5.02433 20.2108 5.78924 20.9757 6.73005 21.455C7.79961 22 9.19974 22 12 22C14.8003 22 16.2004 22 17.27 21.455C18.2108 20.9757 18.9757 20.2108 19.455 19.27C20 18.2004 20 16.8003 20 14Z"
				fill="currentColor"
			/>
			<path
				d="M16 3V3C18.2091 3 20 4.79086 20 7V14C20 16.8003 20 18.2004 19.455 19.27C18.9757 20.2108 18.2108 20.9757 17.27 21.455C16.2004 22 14.8003 22 12 22V22C9.19974 22 7.79961 22 6.73005 21.455C5.78924 20.9757 5.02433 20.2108 4.54497 19.27C4 18.2004 4 16.8003 4 14V7C4 4.79086 5.79086 3 8 3V3M16 3V3C16 1.89543 15.1046 1 14 1H10C8.89543 1 8 1.89543 8 3V3M16 3V3C16 4.10457 15.1046 5 14 5H10C8.89543 5 8 4.10457 8 3V3M9.5 13.5L11 15L15 11"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.24969 2.25C7.70086 1.04698 8.85094 0.25 10.1358 0.25H13.8638C15.1486 0.25 16.2986 1.04699 16.7497 2.25C18.9587 2.25 20.7495 4.04078 20.7495 6.24982V14.75C20.7495 17.5503 20.7495 18.9504 20.2045 20.02C19.7252 20.9608 18.9603 21.7257 18.0195 22.205C16.9499 22.75 15.5498 22.75 12.7495 22.75H11.2495C8.44925 22.75 7.04912 22.75 5.97956 22.205C5.03875 21.7257 4.27385 20.9608 3.79448 20.02C3.24951 18.9504 3.24951 17.5503 3.24951 14.75V6.25018C3.24951 4.04094 5.04045 2.25 7.24969 2.25ZM8.74969 3C8.74969 3.69036 9.30934 4.25 9.99969 4.25H13.9997C14.6901 4.25 15.2497 3.69036 15.2497 3C15.2497 2.30964 14.6901 1.75 13.9997 1.75H9.99969C9.30934 1.75 8.74969 2.30964 8.74969 3ZM15.5303 11.5303C15.8232 11.2374 15.8232 10.7626 15.5303 10.4697C15.2374 10.1768 14.7626 10.1768 14.4697 10.4697L11 13.9393L10.0303 12.9697C9.73744 12.6768 9.26256 12.6768 8.96967 12.9697C8.67678 13.2626 8.67678 13.7374 8.96967 14.0303L10.4697 15.5303C10.6103 15.671 10.8011 15.75 11 15.75C11.1989 15.75 11.3897 15.671 11.5303 15.5303L15.5303 11.5303Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M16 3V3C18.2091 3 20 4.79086 20 7V14.0001C20 16.8003 20 18.2004 19.4551 19.2699C18.9757 20.2108 18.2108 20.9757 17.2699 21.4551C16.2004 22 14.8003 22 12.0001 22H11.6562C9.17981 22 7.9416 22 6.97392 21.5711C5.8391 21.0681 4.93196 20.1609 4.42897 19.0261C4.00005 18.0584 4.00007 16.8202 4.00011 14.3438V14.3438L4 14M16 3C16 4.10457 15.1046 5 14 5H10C8.89543 5 8 4.10457 8 3M16 3C16 2.63571 15.9026 2.29417 15.7324 2C15.5568 1.69637 15.3036 1.4432 15 1.26756M8 3V3C5.79086 3 4 4.79086 4 7V9.5V10M8 3C8 1.89543 8.89543 1 10 1H12M9.5 13.5L11 15L15 11"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M16 3V3C18.2091 3 20 4.79086 20 7V14C20 16.8003 20 18.2004 19.455 19.27C18.9757 20.2108 18.2108 20.9757 17.27 21.455C16.2004 22 14.8003 22 12 22V22C9.19974 22 7.79961 22 6.73005 21.455C5.78924 20.9757 5.02433 20.2108 4.54497 19.27C4 18.2004 4 16.8003 4 14V7C4 4.79086 5.79086 3 8 3V3M16 3V3C16 1.89543 15.1046 1 14 1H10C8.89543 1 8 1.89543 8 3V3M16 3V3C16 4.10457 15.1046 5 14 5H10C8.89543 5 8 4.10457 8 3V3M9.5 13.5L11 15L15 11"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.2498 2.25C8.44949 2.25 7.04936 2.25 5.9798 2.79497C5.03899 3.27433 4.27409 4.03924 3.79472 4.98005C3.24976 6.04961 3.24976 7.44974 3.24976 10.25V14.75C3.24976 17.5503 3.24976 18.9504 3.79472 20.02C4.27409 20.9608 5.03899 21.7257 5.9798 22.205C7.04936 22.75 8.44949 22.75 11.2498 22.75H12.7498C15.55 22.75 16.9501 22.75 18.0197 22.205C18.9605 21.7257 19.7254 20.9608 20.2048 20.02C20.7498 18.9504 20.7498 17.5503 20.7498 14.75V10.25C20.7498 7.44974 20.7498 6.04961 20.2048 4.98005C19.7254 4.03924 18.9605 3.27433 18.0197 2.79497C16.9501 2.25 15.55 2.25 12.7498 2.25H11.2498Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9 0.25C7.89543 0.25 7 1.14543 7 2.25C7 3.35457 7.89543 4.25 9 4.25H15C16.1046 4.25 17 3.35457 17 2.25C17 1.14543 16.1046 0.25 15 0.25H9ZM15.5303 11.5303C15.8232 11.2374 15.8232 10.7626 15.5303 10.4697C15.2374 10.1768 14.7626 10.1768 14.4697 10.4697L11 13.9393L10.0303 12.9697C9.73744 12.6768 9.26256 12.6768 8.96967 12.9697C8.67678 13.2626 8.67678 13.7374 8.96967 14.0303L10.4697 15.5303C10.6103 15.671 10.8011 15.75 11 15.75C11.1989 15.75 11.3897 15.671 11.5303 15.5303L15.5303 11.5303Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
